import usersIcon from 'features/Onboarding/images/verificationUsers.svg';

import { VerificationStatus } from '../useVerificationStatus/types';
import locales from './locales';
import { VerificationStep } from './types';

type StatusArgs = Pick<
  VerificationStatus,
  'multiKycStatus' | 'totalBeneficiaries' | 'totalBeneficiariesCompleted'
>;

const getBeneficiariesNote = ({
  multiKycStatus,
  totalBeneficiaries,
  totalBeneficiariesCompleted,
}: StatusArgs): string => {
  if (multiKycStatus === 'not-shown') {
    throw new Error('Not possible to create a note');
  }
  if (
    totalBeneficiaries === undefined ||
    totalBeneficiariesCompleted === undefined
  ) {
    throw new Error('The beneficiaries totals must be set to create a note');
  }
  if (multiKycStatus === 'error') {
    return locales.beneficariesErrorNote;
  }
  if (multiKycStatus === 'complete' || multiKycStatus === 'pending') {
    return locales.beneficiariesPendingNote;
  }

  // Casting is safe below as it is know this only returns a single string
  return locales.formatString(locales.beneficariesProgressNote, {
    totalBeneficiaries,
    totalBeneficiariesCompleted,
  }) as string;
};

const getBeneficiariesStep = (status: StatusArgs): VerificationStep => {
  if (status.multiKycStatus === 'not-shown') {
    throw new Error('Not possible to return a not-shown step');
  }
  return {
    icon: usersIcon,
    label: locales.beneficiariesDocuments,
    markedAsCurrentForPages: ['beneficiaries-docs-intro', 'beneficiaries-docs'],
    nextPage: 'beneficiaries-docs-intro',
    notes: getBeneficiariesNote(status),
    status: status.multiKycStatus,
  };
};

export default getBeneficiariesStep;
